module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabrielsTrail_BW-dc0575058b92b65c4d604c717c937c9d.jpg";